import * as M from '@core/api/models';
import { SelectOption } from '@shared/components/form/form-wizard/models/form-wizard.models';

export interface InvestmentCompanySwitchOption {
  label: string;
  value: string;
}

function normalizeCompanyName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  return trimmed.length > 0 ? trimmed : 'Bez nazwy';
}

function compareByLabel(a: { label: string }, b: { label: string }): number {
  return a.label.localeCompare(b.label, 'pl', { sensitivity: 'base' });
}

export function mapCompaniesToFormOptions(companies: readonly M.CompanyDto[]): SelectOption[] {
  return companies
    .map((company) => ({
      label: normalizeCompanyName(company.companyName),
      value: company.id,
    }))
    .sort(compareByLabel);
}

export function mapCompaniesToSwitchOptions(
  companies: readonly M.CompanyDto[]
): InvestmentCompanySwitchOption[] {
  return companies
    .map((company) => ({
      label: normalizeCompanyName(company.companyName),
      value: String(company.id),
    }))
    .sort(compareByLabel);
}

export function resolveOptionalCompanyId(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  }

  return null;
}

export function buildInvestmentCompanySwitchRequest(
  investment: M.InvestmentDetailsWithCountsDto,
  companyId: number
): M.InvestmentRequest {
  const title = typeof investment.title === 'string' ? investment.title.trim() : '';
  if (!title) {
    throw new Error('Nazwa inwestycji jest wymagana');
  }

  return {
    title,
    companyId,
    description: investment.description,
    buildingPermitNumber: investment.buildingPermitNumber,
    internalNote: investment.internalNote,
  };
}
